function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpareparts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "spareparts") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    "data-name": "Path 940",
    d: "m.1 21.258 3.462 2.626v5.6L.1 27.093zm4.452 8.766h8.9v-6h-8.9zm9.893-.539 3.455-2.392v-5.835l-3.462 2.625zM18 19.868l-4.053 3.073H4.054L0 19.868l4.328-2.844h9.344zm-4.053-.135c0-.9-2.214-1.625-4.946-1.625s-4.946.727-4.946 1.625S6.268 21.357 9 21.357s4.947-.728 4.947-1.625z",
    transform: "translate(3 -11.523)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpareparts);
export default __webpack_public_path__ + "static/media/spareparts.34c26cab67e615531c004a255f7b563d.svg";
export { ForwardRef as ReactComponent };